import * as React from 'react';
import * as styles from './Gallery.css';

export const Gallery: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
